import gql from 'graphql-tag';

import { VendorDetails } from '../../../../../../../graphql/fragments/account';

const albumFolderDetails = gql`
  fragment albumFolderDetails on AlbumFolder {
    id
    name
    join_code
    join_type
    joins_enabled
    org_pay_photo_pricing_enabled
    album_type
    album_subtype
    account {
      ...VendorDetails
    }
    social_share_enabled
    hash_code
    display_photos_attribution
    display_public_photo_attribution
    picture_day_enabled
    upload_mode
    is_web_gallery
    web_gallery_price_per_photo {
      value
      currency
    }
    photo_pricing {
      id
      print_product_items(slice: { limit: 1 }) {
        total
      }
    }
    has_album
    file_comment_privacy
    green_screen_enabled
    multi_pose_print_packages_enabled
    multi_identity_print_packages_enabled
    multi_identity_digital_bundles_enabled
    products_display_order {
      all_products
      digital_products
    }
  }
  ${VendorDetails}
`;

export default albumFolderDetails;
